import {ButtonDropdown, DropdownHandler, EMPHASIS} from '@forecast-it/design-system';
import {DASHBOARD_DATE_PRESETS, CUSTOM_RANGE_ID} from '../constants/dashboardDatePresets';

interface Props {
	value: string | null;
	onChange: (presetId: string) => void;
}

export function RangePresetSelect({value, onChange}: Props) {
	const selected = DASHBOARD_DATE_PRESETS.find(p => p.id === value);
	const label = selected?.label ?? 'Select range';

	return (
		<DropdownHandler>
			<DropdownHandler.Trigger>
				<ButtonDropdown emphasis={EMPHASIS.LOW} data-cy="dashboard-range-preset">
					{label}
				</ButtonDropdown>
			</DropdownHandler.Trigger>
			<DropdownHandler.Content offset={4}>
				{DASHBOARD_DATE_PRESETS.filter(p => p.id !== CUSTOM_RANGE_ID).map(preset => (
					<DropdownHandler.Item key={preset.id} onClick={() => onChange(preset.id)}>
						{preset.label}
					</DropdownHandler.Item>
				))}
				<DropdownHandler.Separator />
				<DropdownHandler.Item onClick={() => onChange(CUSTOM_RANGE_ID)}>Custom range</DropdownHandler.Item>
			</DropdownHandler.Content>
		</DropdownHandler>
	);
}
